/**
 * Haelt die Produktvorschauen im Menue innerhalb der Menueflaeche.
 *
 * Die Vorschau haengt am jeweiligen Produktlink und klappt nach rechts oben
 * auf. Bei den unteren Produkten einer Spalte ragte sie dadurch ueber den
 * unteren Rand des Menues hinaus - und wurde dort abgeschnitten, weil das
 * Menuepanel seinen Inhalt mit overflow beschneidet.
 *
 * Statt das Beschneiden abzuschalten wird die Vorschau verschoben: Sie bleibt
 * an ihrem Produkt, rutscht aber so weit nach oben beziehungsweise zur Seite,
 * dass sie vollstaendig auf der Menueflaeche liegt. Das ist die verlaesslichere
 * Loesung, denn sie haengt nicht davon ab, wie viele Produkte oder Optionen
 * eine Kategorie hat.
 *
 * Gerechnet wird erst beim Ueberfahren. Vorher steht die Vorschau zwar schon
 * im Dokument, aber ihre Groesse haengt an geladenen Bildern und Schriften -
 * eine Messung auf Vorrat waere haeufig falsch. visibility: hidden behaelt das
 * Layout, die Masse stimmen also auch im unsichtbaren Zustand.
 */

/** Luft zum Rand des Menues, damit die Karte nicht bündig anklebt. */
const RAND = 12;

/**
 * Verschiebt eine Vorschau so, dass sie ganz im Menue liegt.
 *
 * @param {HTMLElement} vorschau
 */
function platziere(vorschau) {
  /*
   * Massgeblich ist die Flaeche, die tatsaechlich beschneidet: das Submenue.
   * Die innere .mega-menu-Flaeche reicht ein Stueck weiter nach unten - wer
   * gegen sie rechnet, laesst die Karte genau um diesen Unterschied ueberstehen.
   */
  const panel = vorschau.closest('.menu-list__submenu') || vorschau.closest('.mega-menu');
  if (!panel) return;

  // Erst zuruecksetzen: sonst rechnet die zweite Messung mit dem Ergebnis der
  // ersten weiter und die Karte wandert bei jedem Ueberfahren ein Stueck.
  vorschau.style.top = '';
  vorschau.style.insetInlineStart = '';

  const flaeche = panel.getBoundingClientRect();
  const karte = vorschau.getBoundingClientRect();
  if (!karte.height) return;

  const stil = getComputedStyle(vorschau);
  const oben = parseFloat(stil.top) || 0;
  const links = parseFloat(stil.insetInlineStart) || 0;

  /*
   * Zuerst nach oben ziehen, falls die Karte unten austritt, danach wieder
   * nach unten, falls sie dabei oben austraete. In dieser Reihenfolge gewinnt
   * die obere Kante - eine Karte, die oben abgeschnitten ist, verliert ihre
   * Ueberschrift und damit den Bezug zum Produkt.
   */
  let versatzY = Math.min(0, flaeche.bottom - RAND - karte.bottom);
  versatzY = Math.max(versatzY, flaeche.top + RAND - karte.top);
  if (versatzY) vorschau.style.top = oben + versatzY + 'px';

  // Seitlich klappt die Karte auf die andere Seite des Links, wenn rechts
  // kein Platz mehr ist.
  if (karte.right > flaeche.right - RAND) {
    // Gespiegelt: die Karte legt sich links neben den Link, mit derselben
    // kleinen Ueberlappung wie sonst rechts.
    vorschau.style.insetInlineStart = 14 - karte.width + 'px';

    if (vorschau.getBoundingClientRect().left < flaeche.left + RAND) {
      // Auch links kein Platz: dann lieber rechts anschlagen als heraushaengen.
      vorschau.style.insetInlineStart = links + (flaeche.right - RAND - karte.right) + 'px';
    }
  }
}

/*
 * Einmal messen genuegt nicht: die Bilder in der Karte werden nachgeladen und
 * die Schrift wird nachtraeglich ersetzt. Beides aendert die Hoehe, nachdem
 * die erste Rechnung schon gelaufen ist - die Karte stand dann wieder unten
 * ueber. Der Beobachter rechnet deshalb bei jeder Groessenaenderung neu.
 *
 * Eine Endlosschleife entsteht dabei nicht: verschoben wird nur die Position,
 * die Groesse bleibt unangetastet.
 */
const beobachter =
  'ResizeObserver' in window
    ? new ResizeObserver((eintraege) => {
        for (const eintrag of eintraege) platziere(eintrag.target);
      })
    : null;

document.addEventListener(
  'pointerenter',
  (ereignis) => {
    const ziel = ereignis.target;
    if (!(ziel instanceof Element)) return;

    const link = ziel.closest?.('.mega-menu__category-product');
    if (!link) return;

    const vorschau = link.querySelector('.mega-menu__product-preview');
    if (!vorschau) return;

    platziere(vorschau);
    if (beobachter && !vorschau.dataset.dpBeobachtet) {
      vorschau.dataset.dpBeobachtet = 'ja';
      beobachter.observe(vorschau);
    }
  },
  { capture: true }
);
